//Import Css
import 'bootstrap';
// import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import 'pc-bootstrap4-datetimepicker/build/css/bootstrap-datetimepicker.css';
import 'simple-line-icons/css/simple-line-icons.css'
import 'flag-icon-css/css/flag-icon.min.css'
import 'bootstrap-social/bootstrap-social.css'
import 'flatpickr/dist/flatpickr.css'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import 'vue2-timepicker/dist/VueTimepicker.css';
//import css
import '@/assets/default/app.min.css'
// import '@/assets/default/style-responsive.min.css'
import '@/assets/default/theme/red.min.css'
// import '@/assets/default/style.css'

// import 'vue-sidebar-menu/dist/vue-sidebar-menu.css'

// import mixins
import mixinMethods from '@/assets/mixin/methods.js'

import Vue from 'vue'
import App from './App.vue'

// apm plugin
import { ApmVuePlugin } from '@elastic/apm-rum-vue'

//for older browser compatibility
import 'es6-promise'

import VueX from 'vuex'

//routes
import router from './Options/router.js'

//store
import storeOptions from './store/store.js'

//import env
import env from './env.js';

//axios
import Axios from 'axios'
Axios.defaults.baseURL = env.urlStart;
Vue.prototype.$http = Axios; // to run axios, just use this.$http


//vue bootstrap
import VueBootstrap from 'bootstrap-vue'

//vuetify
const Vuetify = () => import('vuetify')

//VueInsProgress
import VueInsProgressBar from 'vue-ins-progress-bar'

//import SweetAlert
import VueSweetalert2 from 'vue-sweetalert2';
import 'sweetalert2/dist/sweetalert2.min.css';

//import googlemaps
import * as VueGoogleMaps from 'vue2-google-maps'

//import vue meta
import VueMeta from 'vue-meta';

//import flatPickr
import flatPickr from 'vue-flatpickr-component';

//import MultiSelect
import MultiSelect from 'vue-multiselect';

//add panel for global use
import VuePanel from './plugins/panel/'

//import json to excel converter
import JsonExcel from 'vue-json-excel'

// import socketio from 'socket.io-client';
import VueSocketIO from 'vue-socket.io';

// export const SocketInstance = socketio('http://localhost:8000');

Vue.use(new VueSocketIO({
  debug: false,
  connection: env.urlStart,
  // options: { path: "/my-app/" } //Optional options
}))

// //import SSR
// const renderer = require('vue-server-renderer').createRenderer()
// //Render the Vue instance to HTML
// renderer.renderToString(app).then(html => {
//   console.log(html)
// }).catch(err => {
//   console.error(err)
// })

//Vue use 
Vue.use(Vuetify)
Vue.use(VueX)
Vue.component('downloadExcel', JsonExcel)
Vue.use(VueBootstrap)
Vue.use(VueInsProgressBar, {
  position: 'fixed',
  show: true,
  height: '3px'
})
Vue.use(VueSweetalert2);
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyB-HQz5XF0qUyvvRjUjQU1raI_JT5gdNws',
    libraries: 'places'
  }
})

import vueUniversalTable from './views/table/vue_universal_table'
import ExportExcelModal from './components/ExportExcelModal.vue'
Vue.component('vue-universal-table' , vueUniversalTable);
Vue.component('flat-pickr', flatPickr);
Vue.component('MultiSelect' , MultiSelect);
Vue.component('export-excel-modal', ExportExcelModal);

Vue.use(VuePanel);
Vue.use(VueMeta, {
  // optional pluginOptions
  refreshOnceOnNavigation: true
})

Vue.mixin({
  methods : mixinMethods
})

Vue.config.productionTip = env.productionMode;

const store  =  new VueX.Store(storeOptions)

router.beforeEach((to, from, next) => {
  const currentUser = store.getters.currentUser;
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);

  if(!requiresAuth) next();
  else if(requiresAuth && !currentUser) next('login'); // if page needs login and no user data, redirect to login page
  else{
    var user = currentUser;

    Axios.get('/api/auth', {headers : {Authorization : "Bearer " + user.token}})
    .then((resp)=>{
      if(resp.data.code != 200)
        throw new Error(resp.data.message);
      if(!requiresAuth && currentUser) next({ name : 'Highlights'});
      else next(); 
    })
    .catch(async (err)=>{
      console.log(err);
      alert("Session Has Expired. Please Relogin")
      Axios.post('/api/auth/logout')
      .then((resp)=>{
        if(resp.data.code != 200)
          throw new Error(resp.data.message);
        store.dispatch('setUser', null)
        Axios.defaults.headers.common['Authorization'] = "";
        
        
      })
      .catch((err)=>{
        console.log(err);
      })

      next('/login')
    })
  }

   //if page doesnt need login and user have loggined , redirect to home page
  //if page doesnt need login and user have not login, go to that page
})

//inject Vue to Id = App
new Vue({
  el : '#app',
  store,
  router : router,
  render: h => h(App),
})

//Google Analytics
import VueGtag from "vue-gtag";
Vue.use(VueGtag, {
  config: { id: env.gaId }
}, router);

Vue.use(ApmVuePlugin, {
  router,
  config: {
    serviceName: env.serviceName ? env.serviceName : 'dso-dashboard',
    // agent configuration
    serviceVersion : '1.0.0',
    environment : env.environment ? env.environment : 'development',
    serverUrl : env.serverUrl ? env.serverUrl : 'http://localhost:8200'
  }
})


function logout(){
  
  //delete token 
}
